import {
  Text,
  Button,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@sfc/ui";

interface NotFoundCardProps {
  currentPath: string;
  primaryHref: string;
  primaryLabel: string;
  secondaryHref?: string;
  secondaryLabel?: string;
}

export function NotFoundCard({
  currentPath,
  primaryHref,
  primaryLabel,
  secondaryHref,
  secondaryLabel,
}: NotFoundCardProps) {
  return (
    <Card className="max-w-2xl">
      <CardHeader>
        <CardTitle>We couldn't find that page</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <Text size="sm" tone="muted-foreground">
          Requested path
        </Text>
        <code className="block rounded-md bg-muted px-3 py-2 text-sm break-all">
          {currentPath}
        </code>
      </CardContent>
      <CardFooter className="flex flex-wrap gap-3">
        <Button nativeButton={false} render={<a href={primaryHref} />}>
          {primaryLabel}
        </Button>
        {secondaryHref && secondaryLabel ? (
          <Button
            variant="outline"
            nativeButton={false}
            render={<a href={secondaryHref} />}
          >
            {secondaryLabel}
          </Button>
        ) : null}
      </CardFooter>
    </Card>
  );
}
